import DismissRegular from 'mini-fluent-svg-icons/lib/icons/DismissRegular';
import multiSelectCancel from 'mini-mail-list-store/lib/actions/multiSelect/multiSelectCancel';
import React, { useEffect } from 'react';
import selectAll from 'mini-mail-list-store/lib/actions/multiSelect/selectAll';
import strings from 'owa-strings/owa-mini-strings';
import unselectAll from 'mini-mail-list-store/lib/actions/multiSelect/unselectAll';
import { addAriaLiveLabel, removeAriaLiveLabel } from 'mini-accessibility';
import { format } from 'owa-strings/utilities/format';
import { Header, HeaderIcons, HeaderIconType, HeaderTitle } from 'mini-header';
import { MailMultiSelectHeaderProps } from '../schema/MailMultiSelectHeader.types';
import { SelectAllIcon } from './SelectAllIcon';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

const styles = require('./MailMultiSelectHeader.scss');
const classNames = require('classnames/bind').bind(styles);

const MailMultiSelectHeader: React.FC<MailMultiSelectHeaderProps> = props => {
    // Extract the props
    const {
        selectedTableView: {
            isInVirtualSelectAllMode,
            itemIds,
            totalRowsInView,
            tableQuery,
            isInCheckedMode,
            selectedItemsIds,
        },
        selectedItemsCount,
        shouldPositionBeFixed = true,
    } = props;

    // Calculate the necessary condition flags
    const isInSearchMode = tableQuery.type === TableQueryType.Search;
    const areAllVisibleItemsSelected = itemIds.length === totalRowsInView;
    const areAllItemsIdsSelected: boolean = selectedItemsIds.size === itemIds.length;
    const areAllSelected =
        isInVirtualSelectAllMode ||
        ((areAllVisibleItemsSelected || isInSearchMode) &&
            isInCheckedMode &&
            areAllItemsIdsSelected); /** If client has all items or table is a search table, returns true if tableView is in multi-select mode and all items are in real selection. */

    // define the icons
    // The left icon
    const leftIcon: HeaderIconType = {
        icon: <SelectAllIcon isAllSelected={areAllSelected} />,
        ariaLabel: !areAllSelected ? strings.selectAllText : strings.unselectAllText,
        onClick: !areAllSelected ? selectAll : unselectAll,
        iconStyle: styles.leftIconStyle,
    };

    // The right icon
    const rightIcon: HeaderIconType = {
        icon: DismissRegular,
        ariaLabel: strings.cancelText,
        onClick: multiSelectCancel,
    };

    // The title
    const title: string = format(strings.multiSelectHeaderText, selectedItemsCount);

    useEffect(() => {
        addAriaLiveLabel(title, 'assertive');
        return () => removeAriaLiveLabel(title);
    }, [title]);

    return (
        <Header
            leftContent={<HeaderIcons icons={[leftIcon]} />}
            rightContent={<HeaderIcons icons={[rightIcon]} rightAligned />}
            titleContent={<HeaderTitle title={title} titleStyles={styles.title} />}
            className={classNames(styles.multiSelectHeader, {
                [styles.fixedAtTop]: shouldPositionBeFixed,
            })}
        />
    );
};

export default MailMultiSelectHeader;
